import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";
import { AppFooter } from "@/components/layout/AppFooter";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[#F8F9FA]">
      <div className="flex flex-1 items-center justify-center px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border border-[#DBE2EA] bg-white p-8 text-center shadow-md">
        <p
          className="text-6xl font-semibold text-[#37699E]"
          style={{ fontFamily: "Lexend Deca, sans-serif" }}
        >
          404
        </p>
        <h1
          className="mt-4 text-2xl font-medium text-[#2D3748]"
          style={{ fontFamily: "Lexend Deca, sans-serif" }}
        >
          {t("notFound.title", "Page introuvable")}
        </h1>
        <p className="mt-2 text-sm text-[#5A6B7A]">
          {t(
            "notFound.description",
            "La page que vous cherchez n'existe pas ou a été déplacée."
          )}
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-[#FFBF07] px-6 py-3 font-semibold text-[#2D3748] shadow-sm transition-all duration-200 hover:bg-[#E5AB06] hover:shadow-md"
        >
          <Home size={18} />
          {t("common.back", "Retour")}
        </Link>
        </div>
      </div>
      <AppFooter variant="app" />
    </div>
  );
};

export default NotFound;
